// extracted by mini-css-extract-plugin
export default {"ResultHeaderMobileMenu":"eCKlw"};